import jquery from "jquery"
import htmlDecode from '../utils/html-decode'
import { getCookie, setCookie, setCookieToPage } from '../utils/cookie.js'
import { __sendVisit } from '../components/send-visit.js'
import {
  addLoadingEffect,
  barbaMarkup,
  hideLoadingEffect,
  saveScheduleEidToCookie,
  saveSeatingChartSize,
  showSeatingChartHeader,
  upatePopupScheduleList
} from '../utils/func.js'

import showSeatLength from '../components/show-seat-length.js'
// import getUrlParameter from '../utils/get-url-parameter.js'
import { _query } from '../utils/query.js'
import { saveGeolocation } from '../components/getGeolocation.js'
import { chartTracking } from '../utils/tracking.js'
// import { triggerMatomo } from '../components/trigger-matomo'


const $: JQueryStatic = jquery
let isVertical:boolean = false

function setAnnouncementCookie (cvalue: string) {
  setCookie('showAnnouncement', cvalue, 1, '')
}

function showAnnouncement () {
  // @ts-ignore
  const shouldHideAnnoucement = getCookie('showAnnouncement') == 1

  if (!shouldHideAnnoucement) {
    // @ts-ignore
    $('#seating-chart-alert-wrapper').modal({ backdrop: false })
    $('#seating-chart-alert-wrapper').on('hide.bs.modal', () => {
      setAnnouncementCookie('1')
    })
  } else {
    // @ts-ignore
    $('#seating-chart-alert-wrapper').modal('hide')
  }
}

type OptProps = {
  container: string
  toggle: string
  placement: string
  html: boolean
  trigger: string
  content: string
}

export function initGreyBarTicketButtonPopoversForCustomer () {
  const opts:OptProps = {
    container: 'body',
    toggle: 'popover',
    placement: 'bottom',
    html: true,
    trigger: '',
    content: '',
	}

  // PREP FOR MOUSE CLICK BLOCKER
  // -- need to make <html> tag have 100% height
  const root = document.getElementsByTagName('html')[0] // '0' to assign the first (and only `HTML` tag)
  root.classList.add('popover-blocker-html-100')

  // Create popover blocker div, hidden by default. When shown, it's got z-index just 1 under popovers.
  // const popoverBlockerDiv = _query('#popover-blocker-div')
  // if (popoverBlockerDiv !== null) {
  $(document.body).append(
    $('<div />', { id: 'popover-blocker-div' }).on('click', function () {
      // clicking cover div just closes all popovers. Down-side is it also covers other
      // @ts-ignore
      $('#mobile-select-event-schedule-block-menus .buttonrow a').popover(
        'hide'
      )
      // hide this blocker div.
      $(this).hide()
    })
  )

  const $buttons = $('#mobile-select-event-schedule-block-menus .buttonrow a')
  $buttons.each(function () {
    // default to trigger focus (means will close if focus is lost)
    $(this).attr('tabindex', '0') // required for trigger 'focus'.
    opts.trigger = 'manual'

    $(this).on('click', function (e) {
      $('#popover-blocker-div').show()
      // @ts-ignore
      $(this).popover('show')
    })

    let data = `<div class="popover-close-wrapper relative" style="width: 100%; height: 10px;"><div role="button" tabindex="0" style="cursor: pointer; display: inline-block; position: absolute;right: -7px;" class="close-btn-wrapper icon-svg--size-16" onclick="$('#${this.id}').popover('hide')"></div></div>${window.helpervars[this.id]}`
    if (!window.helpervars[this.id]) {
      data = ''
    }

    opts.content = htmlDecode(data)

    // @ts-ignore
    $(this).popover(opts)

    if (opts.content == '') {
      $(this).hide()
    }
  })
}

export function switchSeatinChartDirection () {
  const showVerticalUrl = isVertical ? '/v/0' : '/v/1'

	chartTracking(window.myvars, 'switchOrientation', '', 'chart', isVertical ? 'horizontal' : 'vertical')
	window.location.href =
    '/event/view/view/schedule/' +
    window.myvars.scheduleEid +
    '/choice/seating-chart' +
    showVerticalUrl
}

const loadRequest = (div:string, url:string) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      type: 'GET',
      // data: tickets,
      // dataType: 'json',
      cache: false,
      timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
      // showLoading: true,
      success: (data: any, textStatus: any, xhr: any) => {
        $(div).html(data)
        // if (addTracking) {
        //   __sendVisit()
        // }
        if (window.enableExitIntend) window.exitIntent()

        resolve(data)
      },
      error: (jqXHR: any, textStatus: any, errorThrown: any) => {
        reject(jqXHR)
      }
    })
  })
}

async function loadPage (div: string, url: string, addTracking: boolean) {
  await addLoadingEffect()
  await loadRequest(div, url)
  await hideLoadingEffect()
  // this is needed in case there are already seats in the cart
  await showSeatLength()
}

function loadHtml5page () {
  // const showVerticalByUrl = getUrlAddress('v') && getUrlAddress('1')
  const showVerticalUrl = window.myvars.showVertical ?
    '/v/1' :
    ''
  const url = `/event/view/html5-seating-chart-v2/schedule/${window.myvars.scheduleEid}${showVerticalUrl}`

  loadPage('#html5-seating-chart', url, true)

  $('body').attr(
    'data-seatinchart-direction',
    window.myvars.showVertical ? 'isVertical' : 'isHorizontal'
  )
  isVertical = Boolean(window.myvars.showVertical)
  // showVerticalDirection = $('body').attr('data-seatinchart-direction')
}


export async function prep () {
  if (window.myvars.frontEndFullSeatingChartOpen) {
    if (_query('#html5-seating-chart') !== null) {
     loadHtml5page()
    }
  }
}

export const Chart = {
  namespace: 'chart',
  // beforeEnter (data) {
	//
  // },
  afterEnter () {
    // parallax.refresh()
    // alert('__hello world __TS__TS__LOAD')
    // console.debug('chart here!')
    barbaMarkup('chart')
    showSeatingChartHeader()
    // ajaxLoadMenu()
    const popupScheduleList = $('.each-schedule-popup-ul').find(
      '.schedule-item'
    )
    upatePopupScheduleList(popupScheduleList, 'seating-chart')
    setCookieToPage('fromSeatingChart')
    setCookie('currentPage', 'SeatingChart', 1, '')
    showAnnouncement()
    prep()
    // getTierLabel()
    // popperEffect()

    saveScheduleEidToCookie(window.myvars.scheduleEid)
    if (window.helpervars && window.helpervars.isHelping == 'true') {
			if( typeof window.initGreyBarTicketButtonPopovers==='function') window.initGreyBarTicketButtonPopovers()
		} else {
			initGreyBarTicketButtonPopoversForCustomer()
		}

    saveSeatingChartSize()
     // __sendVisit()
    saveGeolocation()

  }

}

window.switchSeatinChartDirection = switchSeatinChartDirection



